<template>
  <div class="hpContact">  <!-- :style="getBg()" -->
    
    <div class="leftBox">
        <div class="leftContent">
            <div class="leftInner">

                <div class="hpcTitle">{{localize('contact_local_mis_distributer')}}</div>
                <!-- contact information -->
                <div class="info hpFont2" v-if="ccInfo==undefined || ccInfo.length==0">            
                  <!-- Or visit our Contact Page to get in touch with us directly. -->
                  {{localize('contact_us_subtitle')}}
                </div>
                <div class="info" v-else> 
                  <div class="hpcSepline"><span></span></div>           
                  <!-- <div class="hpFont2" style="font-weight:500 !important">{{ccInfo.page_title}}</div> -->
                  
                  <div class="hpFont15" style="padding-top:0px;">
                    <ul class="infoList">
                      <li><div class="hpFont15" style="font-weight:400 !important">{{ccInfo.page_subtitle}}</div></li>
                      <li>{{ccInfo.page_summary}}</li>
                      <li>{{ccInfo.contact_tel}}</li>
                      <li><a :href="'mailto:'+ccInfo.contact_email" v-if="ccInfo.contact_email.length>0">{{ccInfo.contact_email}}</a></li>
                      <li><a :href="ccInfo.contact_website" v-if="ccInfo.contact_website.length>0" target="_blank">{{ccInfo.contact_website}}</a></li>
                    </ul>
                  </div>
                </div>
                <!-- link to page -->
                <div class="hpcBtn">
                  <router-link :to="getMainPageLink" class="textLink hpFont1">
                    <span><i class="fal fa-globe"></i>{{localize('goto_contactpage')}}</span>
                    <span><i class="fal fa-globe"></i>{{localize('goto_contactpage')}}</span>
                  </router-link>
                </div>

          </div>
      </div>
    </div>
    <div class="rightBox">
      <video :src="'/img/video/mis-bandw.mp4'" playsinline data-src="" poster="" title="" autoplay loop muted ></video>        
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
        test:'',
        ccInfo:[]
    };
  },
  mounted() {
    this.readContact();
  },
  watch: {
  },
  computed: {
    ...mapState(["response_country"]),
    ...mapGetters(["localeString"]),
    getCountryInfo()
    {
        return this.ccInfo;
    },
    getMainPageLink()
    {
      return this.parsedLocaleString+"/company/contact-us";
    },    
    parsedLocaleString() {
      return this.localeString.indexOf("-") > -1 ? "/" + this.localeString : "";
    },

  },
  methods: {
      readContact()
      {
        //var cc = 'at';
        var cc = this.response_country;
        if(cc.length>0)
        {
          var vm=this;
          var apiURL = "https://api.mis-implants.com/api/countrycontactinfo?cc="+cc;
          fetch(apiURL,{method: 'GET',mode: 'cors',cache: 'no-cache',headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'}})
          .then(function(response){return response.json();})
          .then(function(response)
          {
              vm.ccInfo = response;
              //vm.$set(vm, "collectionsList", response);
              //vm.$set(vm.tempcollections, response);
              //vm.setCollectionsList(response);//update the list
          });         
        }
      },
    getBg()
    {
      return "background-image: url('img/bgContactUs.png');";
    }
  }
};
</script>

<style scoped>
    .hpContact
    {
        margin:7vw 10vw;
        border-radius: 25px;
        clear: both;        
        background-size: cover;
        background-position:  center center;
        position: relative;
        max-height: 65vh;
        height: 65vh;
    }
    .hpContact .leftBox
    {
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
      display: inline-block;
      width: 50%;
      height: 100%;      
      opacity: 1;
      background-color: #1074b7;
      float: left;
    }
    .hpContact .rightBox
    {
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      display: inline-block;
      width: 50%;
      height: 100%;            
      object-fit: cover;   
      opacity: 1;
      background-color: #000;
      float: left;
    }
    .hpContact .rightBox video
    {
      border-top-right-radius: 25px;
      border-bottom-right-radius: 25px;
      width: 100%;
      height: 100%;            
      object-fit: cover;   
    }


    .hpContact .leftBox .leftContent
    {
      padding: 3vw;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    .hpContact .leftBox .leftContent .leftInner
    {
        padding: 3vw;
        text-align: left;
    }



    .hpContact .info 
    {
      text-align: left;
      padding-top: 0px;
    }



    .hpContact .info a
    {
        color:#8ed3ff;
    }
    .hpContact .info a:hover
    {
        color:#fff;
    }
    .infoList
    {
      list-style: none;
    }
    .infoList li
    {
      padding-bottom: 0px;
    }

    .hpcTitle
    {
        clear: both;
        text-align: left;
        width: 100%;
        letter-spacing: -1.5px !important;
        font-weight: 100 !important;
        font-size: 3.2vw;
        line-height: 3.5vw;
        color: #fff;
        padding-bottom: 1vw;
    }
    .hpcBtn
    {
      clear: both;
      padding-top: 40px;
    }
    .hpcBtn a span
    {
      cursor: pointer;
      color: #fff;
      border: solid 2px #fff;   
      clear: both;
      width: 100%;
      display: inline;
      font-weight: 300 !important;     
      border-radius: 30px;
      padding: 12px 20px;      
      transition: all ease 0.3s;    
    }
    .hpcBtn a span i
    {
      padding-right: 5px;
    }

    .hpcBtn a:hover span
    {
      /* padding: 14px 24px; */
    }    
    .textLink
    {
      position: relative;
    }
    .textLink span
    {
      font-weight: 500 !important;
      border-radius: 30px;
      padding: 10px 20px;
      border: solid 2px #fff;      
    }

    .textLink span:nth-child(1)
    {
        font-weight: 500 !important;
    }
    .textLink span:nth-child(2)
    {
      font-weight: 500 !important;
      color: #1074b7;
      background-color: #fff;
      position: absolute;
      top: -15px;
      left: 0px;
      clip-path: inset(100% 0 0 0 );
    }
    .textLink:hover span:nth-child(2)
    {
      clip-path: inset(0 0 0 0);
    }






    .hpcSepline
    {
      padding: 10px 0px 20px 0px;
    }
    .hpcSepline span
    {
      width: 10vw;
      height: 3px;
      background-color: #59ddff;
      display: inline-block;
    }




    @media screen and (max-width: 815px){
      .hpcTitle{
        font-size: 30px;
        width: 100%;
        margin: auto;
        line-height: 32px;
        padding-bottom: 20px;
      }
      .hpcInner{
        padding: 10vw 0;
      }
      .hpContact{
          margin:12vw 5vw 22vw 5vw;
          height: auto;
          min-height: 150vw;          
      }
      .hpcCols{
        flex-direction: column;
        width: 80vw;
      }
      .hpcInner .left{
        padding: 0 2vw;
        max-width: 100%;
      }      
      .hpcInner .right{
          padding: 50px 2vw;
          max-width: 80vw;
          text-align: center;
      }      
      .hpContact .leftBox {
        border-radius: 25px 25px 0px 0px;
        display: block;
        width: 100%;
      }      
    .hpContact .rightBox{
        border-radius: 0px 0px 25px 25px;
        display: inline-block;
        width: 100%;
        height: 60vw;
    }
    .hpContact .rightBox video{ 
      border-radius: 0px 0px 25px 25px;
    }
    .hpContact .leftBox .leftContent .leftInner {
        padding: 8vw 8vw 12vw 8vw;
        text-align: left;
    }    
    }



    /* Portrait ipad pro */
    @media only screen 
      and (min-width: 1024px) 
      and (max-height: 1366px) 
      and (orientation: portrait) 
      and (-webkit-min-device-pixel-ratio: 1.5) 
      {
        .hpContact{
            max-height: 35vh;
            height: 35vh;      
        }      
    }

</style>
